define([
	"dojo/_base/declare",
	"underscore",
	"csi/def",
	"csi/heading/Container",
	"csi/html",
	"csi/middleware/common",
	"csi/middleware/customView/customViewValidateService",
	"csi/model/customView",
	"csi/page/localeProvider",
	"csi/prefs/_base",
	"csi/reflection",
	"csi/service/viewService",
], function(declare, _, def, Container, html, {validateKey}, {getCustomViewKeyMigrationReport}, {isCustomViewContainerTypeKey}, localeProvider, csiPrefs, reflection, {createAttributesStore}) {

	function _render(/*String[]*/keys, /*DOMNode*/refNode) {
		var sep = "\n";
		var text = "";

		_.each(keys, function(key, i) {
			if (text) text += sep;
			text += key;
		}, this);

		html.multiLineText(refNode, text);
	}

	return declare(Container, {
		type: "stringlist",

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: filtering not supported
			return null;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render errors in custom view
			const thisView = ctx.view;
			const cv = ctx.getNode();
			const urlContainer = ctx.getNodeParentURL();
			const key = thisView._getContainerKey(cv);
			const view = thisView._getViewDefinition(key, cv);
			const errors = [];

			if (view === false) {
				// the ProductPresentationRules case is special, ideally the TargetClass of the view would be Style, Food, etc, we didn't do that yet,
				// rather than modify the table, validate the key directly here
				if (key === "ProductPresentationRules") {
					_.each(cv.Keys, (dpkey, n) => {
						if (!validateKey(dpkey)) {
							errors.push(dpkey);
						}
					});

					if (errors.length) {
						_render(errors, refNode);
					}

					return true;
				}

				thisView.moveView(key, urlContainer);
				html.multiLineText(refNode, thisView.ERROR_MISSING);
				return true;
			}

			if (!view) {
				thisView.orphanView(cv.$URL);
				html.multiLineText(refNode, thisView.ERROR_ORPHAN);
				return true;
			}

			if (!view.supportsCustomViews()) {
				thisView.moveView(key, urlContainer);
				html.multiLineText(refNode, thisView.ERROR_PREFS);
				return true;
			}

			if ((key.indexOf(view.getViewPreferenceKey()) < 0) && !isCustomViewContainerTypeKey(key)) {
				thisView.moveView(key, urlContainer);
				html.multiLineText(refNode, thisView.ERROR_KEY);
				return true;
			}

			if (!cv.TargetClass) {
				if (key === "ProductPresentationAttributeSettings") {
					// we didn't specify the value of the TargetClass for ProductPresentationAttributeSettings on 7.4 , need to track them so that generate the scripts accordingly
					const targetType = thisView.extractTargetClassFromCV(cv, key);
					thisView.specifyTargetClass(cv.$URL, targetType);
				} else {
					thisView.orphanView(cv.$URL);
				}

				html.multiLineText(refNode, thisView.ERROR_TARGET);
				return true;
			}

			var nestedViews = _.keys(cv.NestedViews || {});
			if (nestedViews.length) {
				var keysNested = thisView._getNestedViewKeys(view);

				_.each(nestedViews, function(keyView) {
					if (_.indexOf(keysNested, keyView) < 0) {
						// check if view type is derived from the other - it is possible that view is defined
						// on derived class while nested views are defined on base class, or the opposite where view is
						// defined on base class while nested views are defined on derived class
						var keyObj = def.decomposeViewKey(csiPrefs.decomposeKey(keyView).view);
						var id = keyObj.id;
						var type = keyObj.type;
						var rc = reflection.getClass(type);

						if (!rc || !_.some(keysNested, function(k) {
							keyObj = def.decomposeViewKey(csiPrefs.decomposeKey(k).view);
							var id2 = keyObj.id;
							var type2 = keyObj.type;
							var rc2 = reflection.getClass(type2);

							if (!rc2) {
								return false;
							}

							return (id == id2) && (rc.isDerivedFrom(type2) || rc2.isDerivedFrom(type));
						})) {
							errors.push(keyView);
						}
					}
				});

				if (errors.length) {
					thisView.errorNested(key, errors);
					_render(errors, refNode);
					return true;
				}

				return false;
			}

			// validate keys
			const attributeStore = createAttributesStore(view, localeProvider);
			const report = getCustomViewKeyMigrationReport(urlContainer, attributeStore, cv);

			thisView.addReport(cv.TargetClass, report);

			return thisView.renderReport(refNode, report);
		},
	});
});